import React, { useState, useEffect } from 'react';
import axios from '../config/axios';
import { testCorsConnection, testModelsEndpoint, testConnection } from '../utils/corsTest';

const ModelsPage = () => {
  const [models, setModels] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [testResult, setTestResult] = useState(null);

  useEffect(() => {
    fetchModels();
  }, []);

  const fetchModels = async () => {
    try {
      setLoading(true);
      // Replace with your actual API endpoint for models
      const response = await axios.get('/api/models');
      setModels(response.data);
    } catch (err) {
      setError('Failed to fetch models');
      console.error('Error fetching models:', err);
    } finally {
      setLoading(false);
    }
  };

  const handleCorsTest = async () => {
    setTestResult('Testing CORS...');
    const result = await testCorsConnection();
    setTestResult(result.success ? 'CORS test passed!' : `CORS test failed: ${result.error}`);
  };

  const handleModelsTest = async () => {
    setTestResult('Testing models endpoint...');
    const result = await testModelsEndpoint();
    setTestResult(result.success ? 'Models endpoint test passed!' : `Models endpoint test failed: ${result.error}`);
  };

  const handleConnectionTest = async () => {
    setTestResult('Testing connection...');
    const result = await testConnection();
    setTestResult(result.success ? 'Connection test passed!' : `Connection test failed: ${result.error}`);
  };

  if (loading) {
    return (
      <div className="page-content">
        <h2>Models</h2>
        <div className="loading">Loading models...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="page-content">
        <h2>Models</h2>
        <div className="error">{error}</div>
        <div className="cors-test-section">
          <h3>CORS Test Tools</h3>
          <button className="btn btn-secondary" onClick={handleConnectionTest}>Test Connection</button>
          <button className="btn btn-secondary" onClick={handleCorsTest}>Test CORS Connection</button>
          <button className="btn btn-secondary" onClick={handleModelsTest}>Test Models Endpoint</button>
          {testResult && <div className="test-result">{testResult}</div>}
        </div>
      </div>
    );
  }

  return (
    <div className="page-content">
      <h2>Models</h2>
      <div className="models-container">
        {models.length === 0 ? (
          <div className="no-models">
            <p>No models found. Create your first model to get started.</p>
            <button className="btn btn-primary">Create Model</button>
          </div>
        ) : (
          <div className="models-grid">
            {models.map((model) => (
              <div key={model.id} className="model-card">
                <h3>{model.name}</h3>
                <p className="model-description">{model.description}</p>
                <div className="model-stats">
                  <span className="stat">Accuracy: {model.accuracy}%</span>
                  <span className="stat">Status: {model.status}</span>
                </div>
                <div className="model-actions">
                  <button className="btn btn-secondary">Edit</button>
                  <button className="btn btn-primary">Deploy</button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
      
      {/* CORS Test Section */}
      <div className="cors-test-section">
        <h3>CORS Test Tools</h3>
        <button className="btn btn-secondary" onClick={handleConnectionTest}>Test Connection</button>
        <button className="btn btn-secondary" onClick={handleCorsTest}>Test CORS Connection</button>
        <button className="btn btn-secondary" onClick={handleModelsTest}>Test Models Endpoint</button>
        {testResult && <div className="test-result">{testResult}</div>}
      </div>
    </div>
  );
};

export default ModelsPage; 